import React, { useState } from 'react';
import { CardArt, ProgressCircle } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

const CardDetails = ({ imageSource }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <CardArt size="lg" tilt={true}>
      {(!isLoaded || imageSource === '') && (
        <div
          className="width-full"
          style={{
            minHeight: 120, background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <ProgressCircle />
        </div>
      )}
      <img
        className="width-full"
        alt="card-type"
        src={imageSource}
        style={{ display: isLoaded ? 'block' : 'none' }}
        onLoad={() => setIsLoaded(true)}
      />
    </CardArt>
  );
};

export default CardDetails;

CardDetails.propTypes = {
  imageSource: PropTypes.string.isRequired,
};
